import styled from "styled-components";
import { BodyMedium } from '../../../components/typography/styled'

export const StatusSection = styled.div`
  background-color: ${({ theme }) => theme.palette[50]};
  border: 1px solid ${({ theme }) => theme.grey[300]};
  border-radius: 8px;
  padding: 24px;
  max-width: 800px;
`

export const StatusRow = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-bottom: 16px;
  gap: 12px;
  &:last-child {
    margin-bottom: 0;
  }
`

export const StatusLabel = styled(BodyMedium)`
  color: ${({ theme }) => theme.palette[600]};
  font-weight: 600;
  min-width: 150px;
`

export const StatusValue = styled(BodyMedium)`
  color: ${({ theme }) => theme.palette[800]};
  display: flex;
  align-items: center;
  gap: 8px;
`

export const StatusIndicator = styled.div<{ active: boolean }>`
  width: 12px;
  height: 12px;
  border-radius: 50%;
  background-color: ${({ active }) => active ? '#229B61' : '#E85048'};
`
